// Export types and base classes
// Re-export for convenience

import { BehaviorConstructor } from "./types";
import { WorldMaker } from "../WorldMaker";

export * from "./types";
export { WorldMaker } from "../WorldMaker";

// Systems have been removed from this project
// export { DebugSystem } from "../systems";

// Export specific behaviors
export { RotationBehavior } from "./RotationBehavior";
export { ColorCycleBehavior } from "./ColorCycleBehavior";
export { ColorOnClickBehavior } from "./ColorOnClickBehavior";
export { CharacterBehavior } from "./CharacterBehavior";
export { RandomWalkBehavior } from "./RandomWalkBehavior";
export { HealthBehavior } from "./HealthBehavior";
export { DestroyOnDeath } from "./DestroyOnDeath";
export { TransformBehavior } from "./TransformBehavior";
export { FlammableBehavior } from "./FlammableBehavior";
export { RapierSystemBehavior } from "./RapierSystemBehavior";
export { SpawnerBehavior } from "./SpawnerBehavior";
export { RandomScaleBehavior } from "./RandomScaleBehavior";
export { RandomCharacterMeshBehavior } from "./RandomCharacterMeshBehavior";
export { ObjectPickupBehavior } from "./ObjectPickupBehavior";
export { PlayerControlsBehavior } from "./PlayerControlsBehavior";
export { PlayerLifecycleBehavior } from "./PlayerLifecycleBehavior";
export { TemporaryBehavior } from "./TemporaryBehavior";

// Create and export a global world instance
export const world = new WorldMaker();

// Add the helper methods to Element prototype
Element.prototype.getBehavior = function <T extends import("./types").Behavior>(
  behaviorClass: new (element: Element, world: WorldMaker) => T,
): T | null {
  return world.getBehavior(this, behaviorClass);
};

Element.prototype.hasBehavior = function (behaviorClass: BehaviorConstructor): boolean {
  return world.hasBehavior(this, behaviorClass);
};

Element.prototype.getAllBehaviors = function (): import("./types").Behavior[] {
  return world.getAllBehaviors(this);
};

// Systems functions have been removed from this project
// export function registerSystem(systemClass: SystemConstructor): void {
//   world.registerSystem(systemClass);
// }

// export function unregisterSystem(systemClass: SystemConstructor): void {
//   world.unregisterSystem(systemClass);
// }

// export function getSystem<T extends import("../systems/types").System>(
//   systemClass: new (world: WorldMaker) => T,
// ): T | null {
//   return world.getSystem(systemClass);
// }

// export function hasSystem(systemClass: SystemConstructor): boolean {
//   return world.hasSystem(systemClass);
// }

// export function getAllSystems(): import("../systems/types").System[] {
//   return world.getAllSystems();
// }
